export const grossUpTotal = (total) => {
  const remainder = total % 1000
  var grossUp = total
  if (remainder !== 0) {
    grossUp = total - remainder + 1000
  }

  return grossUp
}
